module.exports = __webpack_public_path__ + "static/img/image_home_product_03.002fa0f.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/mobile/resource/images/home/image_home_product_03.png
// module id = 0/dr
// module chunks = 10